import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./ErrorBoundary";
import initSentry from "./utils/initSentry";
import { migrateLegacyThreadStores } from "./utils/anonymousThreadId";
import { fetchGeoData } from "./utils/timezone";

// intialize sentry
initSentry();

// Best-effort fetch of IP-based geo data (Vercel serverless). Once per session.
fetchGeoData();

// Fold the legacy thread_id / website_thread_id stores into thread_ids before
// anything reads the anonymous thread history.
migrateLegacyThreadStores();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
